<template>
    <b-container>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.create', {
                        item: $t('miniCurriculum.carrerInTheCompany'),
                    })
                }}</strong>
            </b-card-header>
            <b-card-body>
                <FormCareerInTheCompany @onSubmit="onSubmit" />
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import FormCareerInTheCompany from './components/FormCareerInTheCompany'
import i18n from '@/i18n'
import { success, danger } from '@/lib/notification'
import api from '@/services/api'
import { mapperCareerInTheCompanyToApi } from './mappers/mapperCareerInTheCompanyToApi'

export default {
    name: 'NewLanguage',
    components: {
        FormCareerInTheCompany,
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit(form, formMainProject, onReset, isLoading) {
            isLoading(true)
            api.post(
                '/career-in-the-company',
                mapperCareerInTheCompanyToApi(form, formMainProject, this.$store.state.profile.currentUserID)
            )
                .then(() => {
                    onReset()
                    this.notificationCareerInTheCompanyCreatedSuccessfully()
                    this.goBack()
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationCareerInTheCompanyCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('miniCurriculum.carrerInTheCompany'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
